import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from '@tanstack/react-router';
import { MotionConfig } from 'motion/react';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { createQueryClient, persistOptions, revalidatePersisted } from '@/lib/query';
import { ThemeController, useResolvedTheme } from '@/lib/theme';
import { createAppRouter } from './router';

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

export function App() {
  const theme = useResolvedTheme();
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={persistOptions}
      onSuccess={() => void revalidatePersisted(queryClient)}
    >
      <MotionConfig reducedMotion="user">
        <TooltipProvider delay={250}>
          <ThemeController />
          <RouterProvider router={router} />
          <Toaster
            position="bottom-right"
            closeButton
            theme={theme}
            offset={{ bottom: 24, right: 24 }}
            mobileOffset={{ bottom: 96 }}
          />
        </TooltipProvider>
      </MotionConfig>
    </PersistQueryClientProvider>
  );
}
